import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'ln-volunteer-svg-icon',
  imports: [NgClass],
  templateUrl: './volunteer-svg-icon.component.html',
  styleUrl: './volunteer-svg-icon.component.css',
})
export class VolunteerSvgIconComponent {
  @Input({ required: true }) class!: string;
  @Input() fillColor = '#372121';
}
